import SessionStorage from './session-storage';
import Vue from "vue";

export default {
    get token() {
        return SessionStorage.get('token_numerama')
    },
    set token(value) {
        return value ? SessionStorage.set('token_numerama', value) : SessionStorage.remove('token_numerama');
    },
    accessToken(email, password) {
        return Vue.httpNumerama.post('api/login', {
            email,
            password
        }).then((response) => {
            this.token = response.data.token;
        });
    },
    refreshToken() {
        return Vue.httpNumerama.post('api/refresh_token').then(response => {
            this.token = response.data.token;
            return response;
        });
    },
    getAuthorizationHeader() {
        return `Bearer ${this.token}`;
    },
}
